import type { NodeViewProps } from "@tiptap/core"
import { useEffect, useState } from "react"

export function useSelected(props: NodeViewProps) {
  const { editor, getPos, node } = props
  const [selected, setSelected] = useState(false)

  useEffect(() => {
    function onSelectionUpdate() {
      const { from, to } = editor.state.selection
      const nodeStart = getPos()
      const nodeEnd = getPos() + node.nodeSize

      const isSelected = from <= nodeStart && to >= nodeEnd

      setSelected(isSelected)
    }

    function onEditorBlur() {
      setSelected(false)
    }

    editor.on("blur", onEditorBlur)
    editor.on("selectionUpdate", onSelectionUpdate)

    return () => {
      editor.off("blur", onEditorBlur)
      editor.off("selectionUpdate", onSelectionUpdate)
    }
  }, [editor, getPos, node.nodeSize])

  return { selected }
}
